import { render } from "./VideoWallPageSidebarSection.vue?vue&type=template&id=8e4c0010&ts=true"
import script from "./VideoWallPageSidebarSection.vue?vue&type=script&lang=ts"
export * from "./VideoWallPageSidebarSection.vue?vue&type=script&lang=ts"

import "./VideoWallPageSidebarSection.vue?vue&type=style&index=0&id=8e4c0010&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__